;(function () {
  angular
    .module('contrast.score')
    .directive('gradeLabel', function (ProgressBarService) {
      return {
        restrict: 'A',
        scope: {
          grade: '='
        },
        link: function (scope, element) {
          var currentClass = ProgressBarService.getBackground(scope.grade)
          element.addClass(currentClass)

          scope.$watch('grade', function (newVal, oldVal) {
            if (newVal && newVal != oldVal) {
              element.removeClass(currentClass)
              currentClass = ProgressBarService.getBackground(scope.grade)
              element.addClass(currentClass)
            }
          })
        }
      }
    })
})()
